import React from 'react';
import { useNavigate } from 'src/utils/useNavigate';
import Button from 'src/components/Button';
import ContentLayout from 'src/components/ContentLayout';
import Text from 'src/components/Text';
import routes from 'src/constants/routes';
import styles from './styles.module.scss';

const AboutCompany: React.FC = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(routes.main);
  };

  return (
    <ContentLayout size="medium" className={styles['root']}>
      <Text type="h2" className={styles['title']}>
        О компании
      </Text>
      <Text type="p">
        Закрытое акционерное общество «ИНФОРАС» (ЗАО «ИНФОРАС», ИНН 7706249306, адрес: 127434, г.
        Москва, шоссе Дмитровское, д. 9, этаж/ком. 3/63, тел. +7 (495) 258-44-08) – дочерняя
        компания ЗАО «1С».
      </Text>
      <Text type="p">
        ЗАО «ИНФОРАС» основано в 2001 г. и специализируется на разработке программного обеспечения,
        автоматизированных программных комплексов, технологий и оборудования, баз данных, создании
        обучающих программ, производстве, сопровождении и реализации программной продукции.
      </Text>
      <Text type="p">
        ЗАО «ИНФОРАС» является уполномоченным представителем в Акционерном обществе «Национальная
        система платежных карт» (далее – АО «НСПК») в целях осуществления
        информационно-технологического взаимодействия с АО «НСПК».
      </Text>
      <Text type="p">
        ЗАО «ИНФОРАС» осуществляет операции платежного агрегатора на основании договора № ББ-000674
        от 27.12.2024 г. с оператором по переводу денежных средств Общество с ограниченной
        ответственностью «Банк Точка» (ООО «Банк Точка», ИНН 9721194461, адрес: 109044, г. Москва,
        вн. тер. г. Муниципальный округ Южнопортовый, пер. 3-й Крутицкий, д. 11, помещ. 7Н, тел. 8
        (495) 787-89-55, лицензия ЦБ РФ № 3545).
      </Text>
      <Text type="h3" className={styles['title']}>
        Способы подачи претензий и порядок их рассмотрения
      </Text>
      <Text type="p">
        Претензии могут быть предъявлены в письменном виде следующими способами:
        <ol>
          <li>По адресу электронной почты: sbp@1c.ru</li>
          <li>
            По адресу места нахождения: 127434, г. Москва, шоссе Дмитровское, д. 9, этаж/ком. 3/63.
          </li>
        </ol>
      </Text>
      <Text type="p">
        При предъявлении претензии необходимо предоставить документы и/или другие данные,
        подтверждающие нарушение Условий осуществления расчетов по переводам, осуществляемым в
        интернете.
      </Text>
      <Text type="p">
        Платежный агрегатор обязуется ответить на полученную претензию в течение 15 (пятнадцати)
        рабочих дней. Этот срок может быть продлен на 10 (десять) рабочих дней, если потребуется
        дополнительная информация для принятия решения. Ответ на претензию направляется по адресу
        электронной почты, а при его отсутствии – по почтовому адресу.
      </Text>
      <Text type="h3" className={styles['title']}>
        Контактная информация
      </Text>
      <Text type="p">
        <ul>
          <li>Телефон БПА-А: +7 (495) 258-44-08</li>
          <li>
            Телефон оператора по переводу денежных средств (ООО «Банк Точка»): 8 (495) 787-89-55
          </li>
        </ul>
      </Text>
      <div className={styles['button-wrapper']}>
        <Button variant="outlined" onClick={handleClick}>
          На Главную
        </Button>
      </div>
    </ContentLayout>
  );
};

export default AboutCompany;
